import { render, staticRenderFns } from "./arvioitava-kokonaisuus-form.vue?vue&type=template&id=9f4ea6ba&scoped=true&"
import script from "./arvioitava-kokonaisuus-form.vue?vue&type=script&lang=ts&"
export * from "./arvioitava-kokonaisuus-form.vue?vue&type=script&lang=ts&"
import style0 from "./arvioitava-kokonaisuus-form.vue?vue&type=style&index=0&id=9f4ea6ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4ea6ba",
  null
  
)

export default component.exports